import React from 'react';
import './Footer.css';
import { trackContact } from '../utils/analytics';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-main">
            <div className="footer-brand">
              <div className="footer-brand-name">LITSCAN</div>
              <p>Scan the night. Find the energy.<br />Never waste a night again.</p>
              <div className="footer-social">
                {/*<a href="https://www.instagram.com/litscan.app/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">*/}
                {/*  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">*/}
                {/*    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>*/}
                {/*  </svg>*/}
                {/*</a>*/}
                {/*<a href="https://www.tiktok.com/@litscan" target="_blank" rel="noopener noreferrer" aria-label="TikTok">*/}
                {/*  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">*/}
                {/*    <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.89a8.16 8.16 0 004.77 1.52V7A4.85 4.85 0 0119.59 6.69z"/>*/}
                {/*  </svg>*/}
                {/*</a>*/}
              </div>
            </div>

            <div className="footer-links">
              <div className="footer-section">
                <h4>App</h4>
                <ul>
                  <li><a href="#features">Features</a></li>
                  <li><a href="#how-it-works">How It Works</a></li>
                  <li><a href="#download">Get Early Access</a></li>
                </ul>
              </div>
              <div className="footer-section">
                <h4>Venues</h4>
                <ul>
                  <li><a href="#pricing">Pricing</a></li>
                  <li><a href="mailto:support@litscan.app" onClick={() => trackContact('email')}>Partner With Us</a></li>
                  <li><a href="mailto:support@litscan.app" onClick={() => trackContact('email')}>Festival Mode</a></li>
                </ul>
              </div>
              <div className="footer-section">
                <h4>Company</h4>
                <ul>
                  <li><a href="/feedback">Contact</a></li>
                  <li><a href="/privacy" onClick={() => trackContact('privacy')}>Privacy Policy</a></li>
                  <li><a href="/terms" onClick={() => trackContact('terms')}>Terms of Service</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-copyright">
          <p>&copy; {currentYear} LITSCAN. All rights reserved.</p>
          <p className="footer-tagline">Scan the night. Find the energy.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

